module.exports = __webpack_public_path__ + "img/valve_sketch.6d8445bf.png";